import React, { Component, Fragment } from "react";
import { SubMenuLink } from "./SubMenuLink";
import { DashboardPageIcon } from "../../Common/Icons";

export default class DashboardLink extends Component {
  render() {
    const { organization } = this.props;
    return (
      <Fragment>
        <SubMenuLink
          pathname={"/fiche-client/" + organization.uen}
          title={"myDashboard"}
        >
          <DashboardPageIcon className={"light-sub-menu-icon"} />
        </SubMenuLink>
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Menu/SubMenu/DashboardLink.js